import React from 'react';
import ReactCalendar from 'react-calendar';
import { CaretLeft, CaretRight } from 'phosphor-react';
import { format } from 'date-fns';

import { mosaiqStyled } from '../../lib';

import { CalendarProps } from './types';

import { CalendarWrapper } from './Calendar.styles';

const Calendar = mosaiqStyled<CalendarProps, HTMLDivElement>(
  ({ calendarProps = {}, maxWidth = 40, popup = false, ...props }) => {
    return (
      <CalendarWrapper $popup={popup} $maxWidth={maxWidth} {...props}>
        <ReactCalendar
          {...calendarProps}
          formatShortWeekday={(_, date) => format(date, 'eeeee')}
          prevLabel={<CaretLeft size={20} />}
          nextLabel={<CaretRight size={20} />}
        />
      </CalendarWrapper>
    );
  },
);

export default Calendar;
